import { render, staticRenderFns } from "./DisplayCouponDetail.vue?vue&type=template&id=7912c75f&scoped=true&"
import script from "./DisplayCouponDetail.vue?vue&type=script&lang=ts&"
export * from "./DisplayCouponDetail.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayCouponDetail.vue?vue&type=style&index=0&id=7912c75f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7912c75f",
  null
  
)

export default component.exports